import Vue from "vue";
import particles from "particles.js";
Vue.use(particles);
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
export default {
  name: "reward",
  computed: {
    ...walletVuex.mapState(["isMobile", "netId", "isWallet"]),
    ...userVuex.mapState(["web3Data"])
  },
  data() {
    return {
      popStakeShow: false,
      popUnStakeShow: false,
      marspApproved: false,
      isClaimLoading: null
    };
  },
  watch: {
    isWallet: {
      handler(bool) {
        if (bool) {
          this.web3Wallet.web3WindQueryFn();
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...walletVuex.mapActions(["doConnect"]),
    async onClaim() {
      if (this.bigNumber(this.web3Data.pending).lte(0)) {
        this.$toasted.error("Insufficient rewards");
        return;
      }
      if (this.isClaimLoading) return;
      this.isClaimLoading = true;
      const tx = await this.web3Wallet.contract("marspump", "marsPumpAddr").send("claim", [this.web3Wallet.address]);
      console.log("tx.transactionHash", tx);
      if (tx.transactionHash) {
        this.$toasted.success("Claim Success!");
      }
      this.isClaimLoading = false;
      await this.web3Wallet.web3WindQueryFn();
    },
    onStake() {
      this.popStakeShow = true;
    },
    onUnstake() {
      this.popUnStakeShow = true;
    },
    async marspApprove(amount) {
      console.log("amount", amount);
      let approveAmt = this.web3Wallet.maxUint256;
      let tx = await this.web3Wallet.contract("token", "marspAddr").send("approve", [this.marsPumpAddr, approveAmt]);
      console.log(tx.transactionHash);
      return tx.transactionHash;
    },
    async checkApprove(amount) {
      try {
        const allowance = await this.web3Wallet.contract("token", "marspAddr").call("allowance", [this.web3Wallet.address, this.marsPumpAddr]);
        console.log("allowance", allowance, amount);
        return this.bigNumber(allowance).gte(amount);
      } catch (err) {}
    },
    onSkip() {
      open(`${this.web3Wallet.explorer.url}/token/${this.marspAddr}`, "target");
    },
    onBuy() {
      open(`${this.uniswap_url}/?inputCurrency=${this.web3Wallet.symbol}&outputCurrency=${this.marspAddr}`, "_blank");
    },
    onCopy() {
      this.$copyText(`${this.marspAddr}`).then(this.$toasted.success(`Copied!`));
    }
  },
  mounted() {
    this.$nextTick(particlesJS.load("particles-js", "/particles/particlesjs-config.json"));
  }
};